var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SmartLink',{staticClass:"btn btn-cta btn-primary d-inline-flex align-items-center",attrs:{"destination":_vm.url,"data-qa":"call to action"}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }